import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import {
  DataService,
  SuveyTakenByUserDTO,
} from "../../bpg-common/services/data.services";
import { BpgEventsService } from "../bpg-events.service";
import { Router, ActivatedRoute } from "@angular/router";
import { DatePipe, Location } from "@angular/common";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { UserAttendanceModel } from "../models/user-attendance.model";
import { ConstantValues } from "../../bpg-common/models/bpg-constants";
import { EnvironmentConfiguration } from "src/app/environment/services/environment.configuration";
import { BpgCommonService } from "../../bpg-common/services/bpg-common.service";
import { MatDialog, MatDialogConfig } from "@angular/material";
import { SelfService } from "../../bpg-self-services/self-services.service.ts";
import * as XLSX from 'xlsx';
@Component({
  selector: "app-event-view-details",
  templateUrl: "./event-view-details.component.html",
  styleUrls: ["./event-view-details.component.css"],
})
export class EventViewDetailsComponent implements OnInit {
  @ViewChild("callAPIDialog", { static: false })
  callAPIDialog: TemplateRef<any>;

  SuveyTakenByUserDTO: SuveyTakenByUserDTO = new SuveyTakenByUserDTO();

  selectedEventsDetails: any;
  awsUrl: any;
  awsBucketName: any;
  eventDetails: any;
  awsUrls: any;
  awsFullUrls: any;
  eventRegistratioDetails: any;
  countOfSignedUser: number;
  loginData: any = JSON.parse(localStorage.getItem("loginData"));
  adminId: any = localStorage.getItem("adminId");
  eventStatus: any;
  eventId: any;
  signedUnsignedUser: any;
  registrationEndDate: any = new Date();
  registrationStartDate: any = new Date();
  date: any = new Date();
  currDate: any = new Date();
  validDate = true;
  approverComment = "";
  approvedBy: number;
  approvedDate: string;
  landingData: any;
  rejected = false;
  approved = false;
  method: string;
  msg1: string;
  msg2: string;
  param: string;
  arrayOfAwsUrls = [];
  signUnsigned: any;
  userAttendance: UserAttendanceModel = new UserAttendanceModel();
  userAttendanceMsg: string;
  successMsg: boolean;
  errorMsg: boolean;
  registerCancelMessage: boolean;
  registerSuccessMessage: boolean;
  alertSuccess: boolean;
  alertSuccessApproved: boolean;
  alertSuccessRejected: boolean;
  alertReminderSentSuccess: boolean;
  eventViewApprove: any;
  iconKeyList: any;
  iconButtonVisible: any;
  alertSuccessCompleted = false;
  message: any;
  invalidComment: boolean;
  invalidCommentForApprove: boolean;
  invalidCommentForReject: boolean;
  selectedEventInfo: any;
  surveyIdDetails: any;
  surveyDetails: any;
  surveyId: any;
  today: any = new Date();
  eventCreateDate: any = Date;
  suveyTakenByUserDetails: any;
  alreadyTakenSurvey = false;
  userId: any;
  launchSurvey: boolean;
  takeSurvey: boolean;
  landingDto: any;
  attendanceData: any;
  numberOfElements: number;
  currentPage = 0;
  currentNumberOfElements: number = ConstantValues.pageLimit;
  totalPages = 0;
  roleList: any;
  tableShow: any;
  noDataFound: boolean;
  limit: number = ConstantValues.pageLimit;
  currentShowingElements: number = ConstantValues.pageLimit;
  searchKey: any;
  buttonType: any;
  chapterLandingDto: any;
  loginDataDetails = JSON.parse(localStorage.getItem("loginData"));
  userAndRoleIdDTO: any;
  chapterList: any;
  isChapterAdmins = false;
  awsFullUrlsPresignedDoc: any;
  link1: any;
  link2: any;
  link3: any;
  meetinglink: any;
  loginDetails: any = JSON.parse(localStorage.getItem("loginData"));
  userRoleDetails: any;
  userIdDto: any;
  isBpgLeadAdmin = false;

  userAttended: any;
  userAttendedEvent: any;
  alertSuccessAttended: any;
  timeOutError: boolean;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  hideAllButtons = false;
  startTime: any;
  userWaitingList = false;
  chapterIds: string;
  siteData: any;
  siteList: any;
  allSiteIds: string;
  bpgName: string;
  bpgId: any;
  siteId: any;
  chapterId: any;
  siteName: string;
  selectedBpgsData: any;
  selectedSiteId: any = 0;
  selectedBpgId: any = 0;
  bpgList: any;
  allBpgIds: any;
  bpgValue: any;
  sendNotification = false;
  alertNotificationSentSuccess = false;
  linkId: any;
  linkEventId: any;
  eventFromNavigate: any;
  fromLink = false;
  userList: any;
  //group sign up changes
  searchTerm: any;
  noUser: boolean;
  userFound: boolean;
  search: boolean;
  userFirstName: string;
  selectedUserList: any = [];
  confirmedUserList: any = [];
  excessList: any = [];
  userExists: boolean;
  signUpSuccess: boolean;
  availablePostions: number;
  screenView = "create";
  existingUsers: any = [];
  userDeleted = false;
  numberOfElementsForExistingUsers: number;
  currentPageForExistingUsers = 0;
  currentNumberOfElementsForExistingUsers: number = ConstantValues.pageLimit;
  limitForExistingUsers: number = ConstantValues.pageLimit;
  currentShowingElementsForExistingUsers: number = ConstantValues.pageLimit;
  isbpgAdmin = false;
  isbpgLeadAdmin = false;
  isNaacAdmin = false;
  isNaacAdminForEvent = false;
  csvData: any[];
  csvHeader: any;
  isFileUploaded: boolean;
  bulkUploadField: any;
  fileName = '';
  fileNameExtensionError: boolean;
  fileTemplateError: boolean;
  usersAddedThroughFileUpload: any = [];
  usersUploadedthroughList: any = [];
  fileUploaded: boolean;
  errMsg = '';
  userInput = 'true'
  alreadyRegisteredList: any = [];
  todaysDateConstant = "yyyy-MM-dd";
  eventsApprovalConstant = "events";
  dataToggleConstant = "data-toggle";
  dataTargetConstant = "data-target";
  selectAllConstant = "Select All";
  navigateOnId:boolean;
  /**
   * @class EventViewDetailsComponent
   * @constructor
   */
  constructor(
    private readonly data: DataService,
    private readonly bpgEventsService: BpgEventsService,
    private readonly router: Router,
    private readonly datePipe: DatePipe,
    private readonly spinnerService: Ng4LoadingSpinnerService,
    private readonly location: Location,
    private readonly route: ActivatedRoute,
    private readonly environment: EnvironmentConfiguration,
    private readonly bpgCommonService: BpgCommonService,
    private readonly dialog: MatDialog,
    private readonly userService: SelfService
  ) {}

  ngOnInit() {
    if (
      this.environment.envName === "dev" ||
      this.environment.envName === "qa" ||
      this.environment.envName === "prod"
    ) {
      if (
        localStorage.getItem("loginData") === null ||
        localStorage.getItem("loginData") === undefined
      ) {
        this.router.navigate(["/log-out"]);
      }
    }
    this.data.setEventPopupOpened(false);
    if (localStorage.getItem("isbpgAdmin") === "true") {
      this.isbpgAdmin = true;
    }
    if (localStorage.getItem("isbpgLeadAdmin") === "true") {
      this.isbpgLeadAdmin = true;
    }
    if (localStorage.getItem("isNaacAdmin") === "true") {
      this.isNaacAdmin = true;
    }
    this.selectedEventsDetails = JSON.parse(
      sessionStorage.getItem("eventDetails")
    );

    if (
      localStorage.getItem("landingPage") != null &&
      localStorage.getItem("landingPage") !== undefined
    ) {
      localStorage.removeItem("landingPage");
    } else {
      localStorage.setItem("landingPage", "eventDetails");
    }
    if (this.adminId === "4" || this.isNaacAdmin) {
      this.getSignedUnsignedUser();
    }
    if (this.loginDetails != null) {
      this.userId = this.loginDetails.userId;
      this.userAndRoleIdDTO = {
        userId: this.loginDetails["userId"],
        roleId: localStorage.getItem("adminId"),
        siteId: null,
      };
    } else {
      localStorage.setItem("eventIdforDetails", this.eventId);
      localStorage.setItem("eventId", this.eventId);
    }

    if (this.selectedEventsDetails === null) {
      this.fromLink = true;
      this.spinnerService.show();
      this.route.params.subscribe((params) => {
        this.linkId = localStorage.getItem("paramaterId");
        if(params.id!==null && params.id!==undefined){
          this.navigateOnId = true;
        }
        if (this.linkId != null) {
          this.linkEventId = localStorage.getItem("paramaterId");
        }
        localStorage.setItem("paramaterId", params.id);

        this.eventFromNavigate = {
          eventId: params.id ? params.id : this.linkEventId,
        };

        this.eventId = this.eventFromNavigate.eventId;

        this.landingData = {
          filter: { eventId: this.eventId },
          moduleId: 0,
          page: 0,
          presentRole: "",
          searchTerm: "",
          size: ConstantValues.pageLimit,
          sortDirection: "DESC",
          sortProperty: "event_create_date",
          uid: "",
        };

        this.bpgEventsService.getAllEvents(this.landingData).subscribe(
          (data) => {
            this.selectedEventsDetails = data.content[0];
            // code for email link - start

            this.userIdDto = {
              userId: this.loginDetails["userId"],
              filter: "forAdminRoleCheck",
              chapterId: this.selectedEventsDetails["chapterId"],
            };

            this.bpgCommonService
              .getUserRoleDetails(this.userIdDto)
              .subscribe((data) => {
                this.userRoleDetails = data;
                for (const user of this.userRoleDetails.adminId) {
                  if (user === 2) {
                    this.landingData = this.bpgEventsService.landingDto();
                    this.isBpgLeadAdmin = true;
                  }
                }
              });

            this.spinnerService.show();
            this.invalidComment = false;
            this.data.eventViewApprove.subscribe(
              (eventViewApprove) => (this.eventViewApprove = eventViewApprove)
            );
            if (this.eventViewApprove === "APPROVE") {
              this.rejected = true;
            }
            if (this.eventViewApprove === "REJECT") {
              this.approved = true;
            }
            window.scrollTo({ left: 0, top: 0, behavior: "smooth" });

            this.link1 = this.selectedEventsDetails.externalRefLnk1;
            this.link2 = this.selectedEventsDetails.externalRefLnk2;
            this.link3 = this.selectedEventsDetails.externalRefLnk3;
            this.meetinglink = this.selectedEventsDetails.virtualMeetingLinks;

            if (this.link1 != null && this.link1.substring(0, 4) !== "http") {
              this.link1 =
                "https://" + this.selectedEventsDetails.externalRefLnk1;
            }
            if (this.link2 != null && this.link2.substring(0, 4) !== "http") {
              this.link2 =
                "https://" + this.selectedEventsDetails.externalRefLnk2;
            }
            if (this.link3 != null && this.link3.substring(0, 4) !== "http") {
              this.link3 =
                "https://" + this.selectedEventsDetails.externalRefLnk3;
            }
            if (
              this.meetinglink != null &&
              this.meetinglink.substring(0, 5) !== "https"
            ) {
              this.meetinglink =
                "https://" + this.selectedEventsDetails.virtualMeetingLinks;
            }

            this.surveyDetails = {
              id: this.selectedEventsDetails.eventId,
            };
            this.getSurveyID();

            this.eventDetails = {
              awsUrl: "",
              category: "EVENT_DOC",
              docName:`${this.selectedEventsDetails.eventId}/${this.selectedEventsDetails.eventDocumentUrl}`,
              eventId: this.selectedEventsDetails.eventId,
            };
            this.adminId = localStorage.getItem("adminId");

            if (
              this.adminId === "1" ||
              this.adminId === "2" ||
              this.adminId === "3" ||
              this.adminId === "4" ||
              this.isNaacAdmin ||
              this.isbpgAdmin ||
              this.isbpgLeadAdmin
            ) {
              this.landingData = this.bpgEventsService.landingDto();
            }

            this.bpgEventsService
              .getAwsUrlsApi(this.eventDetails)
              .subscribe((data) => {
                this.awsUrls = data;
                this.awsFullUrlsPresignedDoc = this.awsUrls.docName;
              });

            this.eventRegistratioDetails = {
              eventId: this.selectedEventsDetails.eventId,
              isConfirmed: false,
              userId: this.loginData.userId,
            };

            this.adminId = localStorage.getItem("adminId");
            this.loginData = JSON.parse(localStorage.getItem("loginData"));
            this.eventStatus = this.selectedEventsDetails.eventStatus;
            this.eventId = this.selectedEventsDetails.eventId;

            this.eventCreateDate = this.datePipe.transform(
              this.selectedEventsDetails.eventCreateDate,
              this.todaysDateConstant
            );
            this.today = this.datePipe.transform(this.date, this.todaysDateConstant); //whatever format you need.

            if (this.eventCreateDate === this.today) {
              this.hideAllButtons = false;
              const currentTime = `${new Date().getHours()}:${new Date().getMinutes()}`;
              const pathName = localStorage.getItem("path");
               if (pathName === this.eventsApprovalConstant) {
                this.startTime = this.selectedEventsDetails.startTime;
              } else {
                this.startTime = this.convertTimeTo24Hours(
                  this.selectedEventsDetails.startTime
                );
              }

              if (currentTime > this.startTime) {
                this.hideAllButtons = true;
              }
            }

            this.selectedEventsDetails.startTime = this.formatTimeShow(
              this.selectedEventsDetails.startTime
            );
            this.registrationStartDate =
              this.selectedEventsDetails.registrationStartDate;
            this.registrationEndDate =
              this.selectedEventsDetails.registrationEndDate;

            this.countSigned();
            this.getSignedUnsignedUser();

            this.currDate = this.datePipe.transform(this.date, this.todaysDateConstant); //whatever format you need.
            this.registrationStartDate = this.datePipe.transform(
              this.registrationStartDate,
              this.todaysDateConstant
            ); //whatever format you need.
            this.registrationEndDate = this.datePipe.transform(
              this.registrationEndDate,
              this.todaysDateConstant
            ); //whatever format you need.

            if (
              this.currDate >= this.registrationStartDate &&
              this.currDate <= this.registrationEndDate &&
              this.eventCreateDate >= this.currDate
            ) {
              this.validDate = false;
            }

            this.iconButtonVisible = sessionStorage.getItem(this.iconKeyList);

            this.landingDto = {
              filter: { eventId: this.eventId },
              moduleId: 0,
              page: 0,
              presentRole: "",
              searchTerm: "",
              size: ConstantValues.pageLimit,
              sortDirection: "ASC",
              sortProperty: "um.user_first_name",
              uid: "string",
            };
            this.currentPage = 1;
            this.listAttendance();

            if (this.adminId !== "1") {
              this.bpgEventsService
                .getChapterDropDown(this.userAndRoleIdDTO)
                .subscribe((data) => {
                  this.chapterList = data;
                  for (const chapter of this.chapterList) {
                    if (
                      chapter.chapterId ===
                      this.selectedEventsDetails.chapterId
                    ) {
                      this.isChapterAdmins = true;
                    }
                  }
                });
            } else {
              this.isChapterAdmins = true;
            }

            //code for email link - end

            this.spinnerService.hide();
          },
          (err) => {
            this.spinnerService.hide();
            if (err.value.statusText === ConstantValues.unknownError) {
              this.timeOutError = true;
            }
          }
        );
      });
    } else {
      this.fromLink = false;
      this.userIdDto = {
        userId: this.loginDetails["userId"],
        filter: "forAdminRoleCheck",
        chapterId: this.selectedEventsDetails["chapterId"],
      };

      this.bpgCommonService
        .getUserRoleDetails(this.userIdDto)
        .subscribe((data) => {
          this.userRoleDetails = data;
          for (let i = 0; i < this.userRoleDetails.length; i++) {
            if (this.userRoleDetails.adminId[i] === 2) {
              this.landingData = this.bpgEventsService.landingDto();
              this.isBpgLeadAdmin = true;
            }
          }
        });

    
      this.spinnerService.show();
      this.invalidComment = false;
      this.data.eventViewApprove.subscribe(
        (eventViewApprove) => (this.eventViewApprove = eventViewApprove)
      );
      if (this.eventViewApprove === "APPROVE") {
        this.rejected = true;
      }
      if (this.eventViewApprove === "REJECT") {
        this.approved = true;
      }
      window.scrollTo({ left: 0, top: 0, behavior: "smooth" });

      this.link1 = this.selectedEventsDetails.externalRefLnk1;
      this.link2 = this.selectedEventsDetails.externalRefLnk2;
      this.link3 = this.selectedEventsDetails.externalRefLnk3;
      this.meetinglink = this.selectedEventsDetails.virtualMeetingLinks;
      if (this.link1 != null && this.link1.substring(0, 4) !== "http") {
        this.link1 = "https://" + this.selectedEventsDetails.externalRefLnk1;
      }
      if (this.link2 != null && this.link2.substring(0, 4) !== "http") {
        this.link2 = "https://" + this.selectedEventsDetails.externalRefLnk2;
      }
      if (this.link3 != null && this.link3.substring(0, 4) !== "http") {
        this.link3 = "https://" + this.selectedEventsDetails.externalRefLnk3;
      }
      if (
        this.meetinglink != null &&
        this.meetinglink.substring(0, 5) !== "https"
      ) {
        this.meetinglink =
          "https://" + this.selectedEventsDetails.virtualMeetingLinks;
      }

      this.surveyDetails = {
        id: this.selectedEventsDetails.eventId,
      };

      this.eventDetails = {
        awsUrl: "",
        category: "EVENT_DOC",
        docName:`${this.selectedEventsDetails.eventId}/${this.selectedEventsDetails.eventDocumentUrl}`,
        eventId: this.selectedEventsDetails.eventId,
      };
      this.adminId = localStorage.getItem("adminId");

      if (
        this.adminId === "1" ||
        this.adminId === "2" ||
        this.adminId === "3" ||
        this.adminId === "4" ||
        this.isNaacAdmin ||
        this.isbpgAdmin ||
        this.isbpgLeadAdmin
      ) {
        this.landingData = this.bpgEventsService.landingDto();
      }

      this.bpgEventsService
        .getAwsUrlsApi(this.eventDetails)
        .subscribe((data) => {
          this.awsUrls = data;
          this.awsFullUrlsPresignedDoc = this.awsUrls.docName;
        });

      this.loginData = JSON.parse(localStorage.getItem("loginData"));

      this.eventRegistratioDetails = {
        eventId: this.selectedEventsDetails.eventId,
        isConfirmed: false,
        userId: this.loginData.userId,
      };

      this.adminId = localStorage.getItem("adminId");
      this.loginData = JSON.parse(localStorage.getItem("loginData"));
      this.eventStatus = this.selectedEventsDetails.eventStatus;
      this.eventId = this.selectedEventsDetails.eventId;
      this.getSurveyID();
      
      this.eventCreateDate = this.datePipe.transform(
        this.selectedEventsDetails.eventCreateDate,
        this.todaysDateConstant
      );
      this.today = this.datePipe.transform(this.date, this.todaysDateConstant); //whatever format you need.

      if (this.eventCreateDate === this.today) {
        this.hideAllButtons = false;
        const currentTime = `${new Date().getHours()}:${new Date().getMinutes()}`;

        const pathName = localStorage.getItem("path");
        if (pathName === this.eventsApprovalConstant) {
          this.startTime = this.selectedEventsDetails.startTime;
        } else {
          this.startTime = this.convertTimeTo24Hours(
            this.selectedEventsDetails.startTime
          );
        }

        if (currentTime > this.startTime) {
          this.hideAllButtons = true;
        }
      }

      this.selectedEventsDetails.startTime = this.formatTimeShow(
        this.selectedEventsDetails.startTime
      );
      this.registrationStartDate =
        this.selectedEventsDetails.registrationStartDate;
      this.registrationEndDate = this.selectedEventsDetails.registrationEndDate;

      this.countSigned();
      this.bpgEventsService
        .getSignedUnsignedUser(this.eventId, this.loginData.userId)
        .subscribe(
          (data) => {
            this.signedUnsignedUser = data;
            this.signUnsigned = this.signedUnsignedUser.isRegistered;
            this.userAttendedEvent = this.signedUnsignedUser.isAttended;
            setTimeout(
              function () {
                this.spinnerService.hide();
              }.bind(this),
              1000
            );
          },
          (err) => {
            this.spinnerService.hide();
            if (err.value.statusText === ConstantValues.unknownError) {
              this.timeOutError = true;
            }
          }
        );

      this.currDate = this.datePipe.transform(this.date, this.todaysDateConstant); //whatever format you need.
      this.registrationStartDate = this.datePipe.transform(
        this.registrationStartDate,
        this.todaysDateConstant
      ); //whatever format you need.
      this.registrationEndDate = this.datePipe.transform(
        this.registrationEndDate,
        this.todaysDateConstant
      ); //whatever format you need.

      if (
        this.currDate >= this.registrationStartDate &&
        this.currDate <= this.registrationEndDate &&
        this.eventCreateDate >= this.currDate
      ) {
        this.validDate = false;
      }

      this.iconButtonVisible = sessionStorage.getItem(this.iconKeyList);

      this.landingDto = {
        filter: { eventId: this.eventId },
        moduleId: 0,
        page: 0,
        presentRole: "",
        searchTerm: "",
        size: ConstantValues.pageLimit,
        sortDirection: "ASC",
        sortProperty: "um.user_first_name",
        uid: "string",
      };
      this.currentPage = 1;
      this.listAttendance();

      if (this.adminId !== "1") {
        this.bpgEventsService
          .getChapterDropDown(this.userAndRoleIdDTO)
          .subscribe((data) => {
            this.chapterList = data;
            for (const chapter of this.chapterList) {
              if (
                chapter.chapterId ===
                this.selectedEventsDetails.chapterId
              ) {
                this.isChapterAdmins = true;
              }
            }
          });
      } else {
        this.isChapterAdmins = true;
      }
    }
  }

  /** For goback from event view details to event list view
   * @class EventViewDetailsComponent
   * @method goBack
   */
  goBack() {
    const tempId = localStorage.getItem("paramaterId");
    localStorage.removeItem("landingPage");
    localStorage.removeItem("paramaterId");
    localStorage.removeItem("eventIdforDetails");
    localStorage.removeItem("eventId");
    if(this.navigateOnId){
      this.navigateOnId = false;
      this.location.back();
      window.scrollTo(0, 0);
    }
    else if (tempId != null && tempId !== undefined) {
      this.router.navigate(["site-home"]);
    } else {
      const pathName = localStorage.getItem("path");
      if (this.selectedEventsDetails.componentName === "eventsListView") {
        this.selectedEventInfo = {
          eventCreateDate: this.selectedEventsDetails.eventCreateDate,
          siteId: this.selectedEventsDetails.selectedSiteId,
          bpgId: this.selectedEventsDetails.selectedBpgId,
          bpgName: this.selectedEventsDetails.selectedBpgName,
          siteName: this.selectedEventsDetails.selectedSiteName,
          searchKey: this.selectedEventsDetails.searchKey,
          path: "eventViewDetails",
        };
        this.data.selectedSiteIdAndPath(this.selectedEventInfo);
        this.router.navigate(["events-list-view"]);
      } else if (
        this.selectedEventsDetails.componentName === "eventsCalendarView"
      ) {
        this.selectedEventInfo = {
          eventCreateDate: this.selectedEventsDetails.eventCreateDate,
          siteId: this.selectedEventsDetails.selectedSiteId,
          bpgId: this.selectedEventsDetails.selectedBpgId,
          bpgName: this.selectedEventsDetails.selectedBpgName,
          siteName: this.selectedEventsDetails.selectedSiteName,
          searchKey: this.selectedEventsDetails.searchKey,
          path: "eventViewDetails",
        };
        this.data.selectedSiteIdAndPath(this.selectedEventInfo);
        sessionStorage.setItem(this.buttonType, "BACK");
        this.router.navigate(["events-calendar"]);
      } else if (pathName === this.eventsApprovalConstant) {
        sessionStorage.setItem(this.buttonType, "BACK");
        localStorage.removeItem("path");
        this.router.navigate([this.eventsApprovalConstant]);
      } else {
        this.location.back();
      }
    }
    window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
  }
  /** For download files of the events
   * @class EventViewDetailsComponent
   * @method downloadAttachments
   */
  downloadAttachments(urls) {
    const extension = urls.substring(urls.lastIndexOf(".") + 1);
    const link = document.getElementById("downloadFiles");
    link.setAttribute("href", urls);
    link.setAttribute("download", urls);
    if (extension === "pdf") {
      link.setAttribute("target", "_blank");
    }
  }

  /** to save and cancel event registration
   * @class EventViewDetailsComponent
   * @method saveEventRegistration
   */
  public saveEventRegistration(type) {
    this.timeOutError = false;
    this.spinnerService.show();
    switch (type) {
      case "REGISTER":
        if (
          this.countOfSignedUser >= this.selectedEventsDetails.maxAttendeece
        ) {
          this.eventRegistratioDetails.isConfirmed = false;
          this.userWaitingList = true;
        } else {
          this.eventRegistratioDetails.isConfirmed = true;
          this.userWaitingList = false;
        }
        break;
      case "CANCEL":
        break;
    }
    this.bpgEventsService
      .saveEventRegistration(this.eventRegistratioDetails)
      .subscribe(
        (_data) => {
          if (type === "REGISTER") {
            setTimeout(() => {
              window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
            }, 500);
            if (this.userWaitingList === false) {
              this.registerSuccessMessage = true;
              this.userWaitingList = false;
            } else if (this.userWaitingList === true) {
              this.registerSuccessMessage = false;
              this.userWaitingList = true;
            }
          }
          if (type === "CANCEL") {
            setTimeout(() => {
              window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
            }, 500);
            this.registerCancelMessage = true;
          }
          setTimeout(
            function () {
              this.registerSuccessMessage = false;
              this.registerCancelMessage = false;
              this.userWaitingList = false;
            }.bind(this),
            6000
          );

          this.bpgEventsService
            .getSignedUnsignedUser(this.eventId, this.loginData.userId)
            .subscribe(
              (data) => {
                this.signedUnsignedUser = data;
                this.signUnsigned = this.signedUnsignedUser.isRegistered;
                this.userAttendedEvent = this.signedUnsignedUser.isAttended;
                this.spinnerService.hide();
              },
              (err) => {
                this.spinnerService.hide();
                if (err.value.statusText === ConstantValues.unknownError) {
                  this.timeOutError = true;
                }
              }
            );
          this.countSigned();
        },
        (err) => {
          this.spinnerService.hide();
          if (err.value.statusText === ConstantValues.unknownError) {
            this.timeOutError = true;
          }
        }
      );
  }

  closeDialog(data) {
    this.method = "openAndCloseMatDialog";
    this.param = data;
    this.msg1 = " Are you sure you want to exit group signup ? ";
  }
  openAndCloseMatDialog(type) {
    if (type === "open") {
      this.data.setEventPopupOpened(true);
      this.getGroupsignupList();
      this.alreadyRegisteredList = [];
      this.signUpSuccess = false;
      this.userExists = false;
      this.screenView = "create";
      this.userFound = false;
      this.userList = null;
      this.userFirstName = "";
      this.search = false;
      this.excessList = [];
      this.searchTerm = null;
      const dialogConfig = new MatDialogConfig();
      dialogConfig.height = "75vh";
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = false;
      const dialogRef = this.dialog.open(this.callAPIDialog, dialogConfig);
      dialogRef.updatePosition({
        bottom: "7vh",
      });
    } else {
      this.data.setEventPopupOpened(false);
      this.alreadyRegisteredList = [];
      this.fileName = '';
      this.userDeleted = false;
      this.noUser = false;
      this.userExists = false;
      this.userFirstName = "";
      this.searchTerm = null;
      this.selectedUserList = [];
      this.confirmedUserList = [];
      this.dialog.closeAll();
      this.bpgEventsService
        .getSignedUnsignedUser(this.eventId, this.loginData.userId)
        .subscribe(
          (data) => {
            this.signedUnsignedUser = data;
            this.signUnsigned = this.signedUnsignedUser.isRegistered;
            this.userAttendedEvent = this.signedUnsignedUser.isAttended;
          },
          (err) => {
            this.spinnerService.hide();
            if (err.value.statusText === ConstantValues.unknownError) {
              this.timeOutError = true;
            }
          }
        );
    }
  }

  removeError()
  {
    this.userFound = false;
    this.userExists = false;
    this.noUser = false;
  }
  /** For searching the table through search term
   * @class AdminComponent
   * @method searchBy
   */
  searchBy() {
    
    this.errMsg = '';
    this.fileUploaded = false;
    this.fileNameExtensionError = false;
    this.fileTemplateError = false;
    this.noUser = false;
    this.signUpSuccess = false;
    this.userExists = false;
    this.search = true;
    this.searchTerm = this.searchTerm ? this.searchTerm : "";
    this.landingDto.searchTerm = this.searchTerm;
    this.userFound = false;
    this.getUserList();
  }
  userSelection($event) {
    this.search = false;
    this.userExists = false;
    this.userFound = false;
    this.signUpSuccess = false;
    this.searchTerm = "";
    this.noUser = false;
    const data = [];
    const data1 = [];
    const index = this.selectedUserList.indexOf($event);
    for (const selectedUser of this.selectedUserList) {
      data.push(selectedUser.userId);
    }
    for (const existingUser of this.existingUsers) {
      data1.push(existingUser);
    }
  
    const index1 = data.indexOf($event.userId);
    const index2 = data1.indexOf($event.userId);
   

    const index3 = this.existingUsers.indexOf($event);
    const userEmail = $event.userId;
    if (index === -1 && index1 === -1 && index2 === -1 && index3 === -1) {
      this.userExists = false;

      // val not found, pushing onto array

      this.selectedUserList.push($event);
      this.confirmedUserList.push($event);
    } else {
      this.userExists = true;
    }
    if (this.signUnsigned && userEmail === sessionStorage.getItem("userEmail")) {
      this.userExists = true;
    }
  }

  removeUser(userId) {
    this.userExists = false;
    this.userFirstName = "";
    this.userList = [];
    const index = this.selectedUserList.indexOf(userId);
    this.selectedUserList.splice(index, 1);
    this.confirmedUserList.splice(index, 1);
    this.search = false;
    if(this.selectedUserList.length === 0 )
    {
      this.fileName = ''
    }
  }

  resetSelectedUser() {
    this.errMsg = '';
    this.fileUploaded = false;
    this.userDeleted = false;
    this.screenView = "create";
    this.signUpSuccess = false;
    this.userExists = false;
    this.selectedUserList = [];
    this.userFound = false;
    this.searchTerm = null;
    this.userList = null;
    this.userFirstName = "";
    this.search = false;
    this.excessList = [];
    this.confirmedUserList = [];
    this.fileNameExtensionError = false;
    this.fileTemplateError = false;
    this.usersUploadedthroughList = [];
    this.alreadyRegisteredList = [];
    this.noUser = false;
  }

  removeUserFromSignUp(id) {
    this.method = "onremoveUserFromSignUpConfirmation";
    this.param = id;
    this.msg1 = " Are you sure you want to sign out the user for this event? ";
  }

  onremoveUserFromSignUpConfirmation(id) {
    this.spinnerService.show();
    this.bpgEventsService
      .removeFromEventGroup(this.eventId, id)
      .subscribe((data) => {
        if (data != null && data !== undefined) {
          this.userDeleted = true;
          this.getGroupsignupList();
          this.countSigned();
          this.spinnerService.hide();
        }
      });
  }

  itemDownloadTemplate() {
    this.spinnerService.show();
    this.fileTemplateError = false;
    this.fileNameExtensionError = false;
    const csvData = [
      ["User First Name", "User Last Name", "Email Address", "WorkDay ID"]
    ];
  const worksheet = XLSX.utils.aoa_to_sheet(csvData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  XLSX.writeFile(workbook, "download-template.csv");
  this.spinnerService.hide();
  }
  removeFile() {
    this.method = "onremoveFileConfirmation";
    this.param = "";
    this.msg1 = " Are you sure you want to remove the uploaded users? ";
  }
  onremoveFileConfirmation() {
    this.fileUploaded = false;
    this.usersUploadedthroughList = [];
    this.bulkUploadField = null;
    this.fileName = "";
    this.fileNameExtensionError = false;
    this.fileTemplateError = false;
    this.errMsg = ''
    let tempFile = [];
    const secondArray = [];
    tempFile = this.selectedUserList;
    if (this.selectedUserList){
      for (const temp of tempFile) {
        if (temp.flag === undefined || temp.flag === null) {
          secondArray.push(temp);
        }
      }
    }
    this.selectedUserList = secondArray;
   
  }
  convertFile(csvfile: any) {
    this.fileNameExtensionError = false;

    if(csvfile.target.files[0].name.split(".").pop() === "csv")
    {
      this.usersUploadedthroughList = [];;
      this.errMsg = '';
      this.fileUploaded = false;
  
      this.fileTemplateError = false;
  
      this.fileName = csvfile.target.files[0].name;
      this.bulkUploadField = csvfile.target.files[0];

      const reader: FileReader = new FileReader();
      reader.readAsText(this.bulkUploadField);
      const lastIndex = 0;
      this.csvData = [];
      reader.onload = (_e) => {
        const csv: any = reader.result;
        const allTextLines = csv.split(/\n/);
        this.csvHeader = allTextLines[0].split(",");
  
        if (!this.fileNameExtensionError) {
          if (
            !(
              this.csvHeader[0].toLowerCase().trim() === "user first name" &&
              this.csvHeader[1].toLowerCase().trim() === "user last name" &&
  
              this.csvHeader[2].toLowerCase().trim() === "email address" &&
              this.csvHeader[3].toLowerCase().trim() === "workday id"
            )
          ) {
            this.fileTemplateError = true;
          }
        }
        if (!this.fileTemplateError && !this.fileNameExtensionError) {
          for (let i = 1; i < allTextLines.length - 1; i++) {
            const data = allTextLines[i].split(",");
            const index = this.usersUploadedthroughList.indexOf(data[1].substring(0, data[1].length - 1));
            const index1 = this.usersUploadedthroughList.indexOf(data[1].substring(0, data[1].length - 1));
            if (index === -1 && index1 === -1) {
        
              // val not found, pushing onto array
              this.usersUploadedthroughList.push(
                { 'userEmailId' : data[2],
                'workdayId' : data[3]
                })
               
        
              }
          }
        }
        if (!this.fileTemplateError && !this.fileNameExtensionError) {
          this.userService
            .getUserDtls([this.usersUploadedthroughList][0])
            .subscribe((data) => {
              if(data.body.message)
              {
                this.errMsg = data.body.message;
  
              }
              data = data.body
              let data1 = []
              const emailList = []
              if (data != null && data !== undefined) {
                
               for(let i = 0 ; i < data.length ; i++)
               {
                data[i] = Object.assign(data[i], {
                  'flag' :  'uploadFile',
            })
            if(this.selectedUserList)
            {
              for(const user of this.selectedUserList)
              {
                emailList.push(user.emailId)
              }
            }
            if(this.existingUsers)
            {
              for(const user1 of this.existingUsers)
                {
                emailList.push(user1.emailId)
              }
            }
                const index = this.selectedUserList.indexOf(data[i]);
                const index1 = this.existingUsers.indexOf(data[i]);
                const index2 = emailList.indexOf(data[i].emailId)
                if (index === -1 && index1 === -1 && index2 === -1) {
            
                  data1 = [...data1,...data[i]];
            
                } 
               
              }
              if(data1)
              {
                for(let i = 0 ; i < data1.length ; i++)
                {
                  data1[i] = Object.assign(data1[i], {
                    'flag' :  'uploadFile',
              })
                }
              }
              if (data != null && data !== undefined && data1 != null && data1 !== undefined) {
                if(data1.length>0)
                {
                  this.selectedUserList = [...this.selectedUserList, ...data1];
                  this.confirmedUserList = [...this.confirmedUserList, ...data1];
                  if(data.body.message === null || data.body.message === undefined)
                  {
                    this.fileUploaded = true;
                  }
  
                  setTimeout(function () {
                    this.fileUploaded = false;
                  }.bind(this), 5000);
  
                }
                
              }
            }
          });
        }
      };
    }
    else
    {
      this.fileNameExtensionError = true;

    }
  }
  /** to list users other than admins
   * @class AdminComponent
   * @method getUserList
   */

  getUserList() {
    this.timeOutError = false;
    this.landingDto.filter = {};
    this.landingDto.filter.leadershipPosition = "USER";

    this.userService.getUserDropDown(this.landingDto).subscribe(
      (data) => {
        this.userList = data;
        if (this.userList.length === 0) {
          setTimeout(() => {
            window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
          }, 500);
          this.noUser = true;
          
        } else {
          if (this.search) {
            setTimeout(() => {
              window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
            }, 500);
            this.userFound = true;
          }
          this.userList.map((i) => {
            i.userFirstName = `${i.userFirstName} ${i.userLastName}`;
            return i;
          });
        }
      },
      (err) => {
        if (err.value.statusText === ConstantValues.unknownError) {
          this.timeOutError = true;
        }
      }
    );
  }
  findbyEmail(e){
    const text = e.target.value;
    if(text.length>2){
     this.searchTerm = text;
     this.searchBy();
    }else{
      this.userList = [];
    }
  }
  
  signUpForGroup() {
    this.errMsg = '';
    this.excessList = [];
    this.userExists = false;
    this.availablePostions =
      this.selectedEventsDetails.maxAttendeece - this.countOfSignedUser;
      this.availablePostions = this.availablePostions < 0 ? 0 : this.availablePostions;
    if (this.availablePostions >= this.confirmedUserList.length) {
      this.method = "onsignUpForGroup";
      this.param = "";
      this.msg1 = " Are you sure you want to sign up for the selected users ? ";
    } else {
      let excessCount = this.confirmedUserList.length - this.availablePostions;

      while (excessCount > 0) {
        const value = this.confirmedUserList[this.confirmedUserList.length - 1];
        this.excessList.push(value);
        this.confirmedUserList.pop(value);
        excessCount--;
      }

      if (this.availablePostions > 0) {
        this.msg1 = `Only ${this.availablePostions} slots are available at the moment. Excess entries will be added in the waiting list and considered as not confirmed.`;
      } else {
        this.msg1 =
          "No slots are available at the moment. Excess entries will be added in the waiting list and considered as not confirmed.";
      }
      this.method = "onsignUpForGroup";
    }
  }
  onsignUpForGroup() {
    this.spinnerService.show();
    const groupData = {
      confirmedUserList: this.confirmedUserList,
      eventId: this.eventId,
      notConfirmedUserList: this.excessList,
      userId: this.loginData.userId
    };
    this.alreadyRegisteredList = [];
    this.bpgEventsService
      .saveEventForGroupRegistration(groupData)
      .subscribe((data) => {
        this.spinnerService.hide();
        if (data != null && data !== undefined) {
          this.alreadyRegisteredList = data.alreadyRegisteredList;
          this.userExists = false;
          this.selectedUserList = [];
          this.confirmedUserList = [];
          this.userFound = false;
          this.userList = null;
          this.userFirstName = "";
          this.search = false;
          this.excessList = [];
          this.searchTerm = null;
          this.fileName = '';
          this.signUpSuccess = true;

          if(data.confirmedUserList.length === 0)
          {
            this.signUpSuccess = false;

          }
          if(this.alreadyRegisteredList.length === 0)
          {
            this.getGroupsignupList();
            this.countSigned();
          }
       
        }
      });
  }
  /** To change the event status based on Approval or Rejection
   * @class EventViewDetailsComponent
   * @method changeEventStatus
   */
  changeEventStatus(type) {
    this.timeOutError = false;
    switch (type) {
      case "APPROVED":
        this.landingData.approvalComment = this.approverComment;
        this.landingData.approvedBy = this.userId;
        this.landingData.eventId = this.selectedEventsDetails.eventId;
        this.landingData.eventStatus = "APPROVED";
        this.approved = true;
        this.rejected = false;
        this.alertSuccessApproved = true;
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        }, 500);
        setTimeout(
          function () {
            this.alertSuccessApproved = false;
          }.bind(this),
          6000
        );
        setTimeout(
          function () {
            this.router.navigate([this.eventsApprovalConstant]);
          }.bind(this),
          6000
        );
        break;

      case "REJECTED":
        this.landingData.approvalComment = this.approverComment;
        this.landingData.approvedBy = this.userId;
        this.landingData.eventId = this.selectedEventsDetails.eventId;
        this.landingData.eventStatus = "REJECTED";
        this.rejected = true;
        this.approved = false;
        this.alertSuccessRejected = true;
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        }, 500);
        setTimeout(
          function () {
            this.alertSuccessRejected = false;
          }.bind(this),
          6000
        );
        setTimeout(
          function () {
            this.router.navigate([this.eventsApprovalConstant]);
          }.bind(this),
          6000
        );
        break;

      case "COMPLETED":
        this.landingData.approvalComment = this.approverComment;
        this.landingData.approvedBy = this.adminId;
        this.landingData.eventId = this.selectedEventsDetails.eventId;
        this.landingData.eventStatus = "COMPLETED";
        this.rejected = false;
        this.approved = false;

        this.alertSuccessCompleted = true;
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        }, 500);

        setTimeout(
          function () {
            this.router.navigate([this.eventsApprovalConstant]);
          }.bind(this),
          6000
        );
        break;

      case "REMINDER":
        this.landingData.approvedBy = this.adminId;
        this.landingData.eventId = this.selectedEventsDetails.eventId;
        this.landingData.eventStatus = "REMINDER";
        this.alertReminderSentSuccess = true;
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        }, 500);
        setTimeout(
          function () {
            this.alertReminderSentSuccess = false;
          }.bind(this),
          6000
        );
        break;

      case "NOTIFICATION":
        this.landingData.chapterIdList = this.chapterId;
        this.landingData.bpgId = this.bpgId;
        this.landingData.eventId = this.selectedEventsDetails.eventId;
        this.landingData.eventStatus = "NOTIFICATION";
        this.alertNotificationSentSuccess = true;
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        }, 500);
        setTimeout(
          function () {
            this.alertNotificationSentSuccess = false;
          }.bind(this),
          6000
        );
        break;
    }
    this.bpgEventsService.updateEventStatus(this.landingData).subscribe(
      (_data) => {},
      (err) => {
        this.spinnerService.hide();
        if (err.value.statusText === ConstantValues.unknownError) {
          this.timeOutError = true;
        }
      }
    );
  }

  /** To select approve with confirmation
   * @class EventViewDetailsComponent
   * @method approveClick
   */
  approveClick() {
    this.invalidCommentForReject = false;
    if (this.approverComment.length === 0) {
      this.invalidCommentForApprove = true;
      document.getElementById("approveBtnClick").removeAttribute(this.dataTargetConstant);
      document.getElementById("approveBtnClick").removeAttribute(this.dataToggleConstant);
    } else {
      document
        .getElementById("approveBtnClick")
        .setAttribute(this.dataTargetConstant, "#myModal");
      document
        .getElementById("approveBtnClick")
        .setAttribute(this.dataToggleConstant, "modal");
      this.invalidCommentForApprove = false;
      this.method = "changeEventStatus";
      this.param = "APPROVED";
      this.msg1 = " Are you sure you want to approve this event ? ";
    }
  }

  /** To select reject with confirmation
   * @class BpgCreateAndEditEventComponent
   * @method rejectClick
   */
  rejectClick() {
    this.invalidCommentForApprove = false;
    if (this.approverComment.length === 0) {
      this.invalidCommentForReject = true;
      document.getElementById("rejectBtnClick").removeAttribute(this.dataTargetConstant);
      document.getElementById("rejectBtnClick").removeAttribute(this.dataToggleConstant);
    } else {
      document
        .getElementById("rejectBtnClick")
        .setAttribute(this.dataTargetConstant, "#myModal");
      document
        .getElementById("rejectBtnClick")
        .setAttribute(this.dataToggleConstant, "modal");
      this.invalidCommentForReject = false;
      this.method = "changeEventStatus";
      this.param = "REJECTED";
      this.msg1 = " Are you sure you want to reject this event ? ";
    }
  }

  /** To select approve with confirmation
   * @class EventViewDetailsComponent
   * @method approveClick
   */
  sendReminderClick() {
   
    document
      .getElementById("emailReminderBtnClick")
      .setAttribute(this.dataTargetConstant, "#myModal");
    document
      .getElementById("emailReminderBtnClick")
      .setAttribute(this.dataToggleConstant, "modal");
    this.method = "changeEventStatus";
    this.param = "REMINDER";
    this.msg1 = " Are you sure you want to send this reminder ? ";
   
  }
  getSignedUnsignedUser() {
    this.bpgEventsService
      .getSignedUnsignedUser(
        this.selectedEventsDetails.eventId,
        this.loginData.userId
      )
      .subscribe(
        (data) => {
          this.signedUnsignedUser = data;
          this.signUnsigned = this.signedUnsignedUser.isRegistered;
          this.userAttendedEvent = this.signedUnsignedUser.isAttended;
          if (
            (this.adminId === "4" || this.isNaacAdmin) &&
            this.signedUnsignedUser.isNaacAdminForEvent
          ) {
            this.isNaacAdminForEvent = true;
          }
          setTimeout(
            function () {
              this.spinnerService.hide();
            }.bind(this),
            1000
          );
        },
        (err) => {
          this.spinnerService.hide();
          if (err.value.statusText === ConstantValues.unknownError) {
            this.timeOutError = true;
          }
        }
      );
  }

  /** To get the number of member signed
   * @class EventViewDetailsComponent
   * @method countSigned
   */
  countSigned() {
    this.timeOutError = false;
    this.bpgEventsService.getCountOfSignedUser(this.eventId).subscribe(
      (data) => {
        this.countOfSignedUser = data;
        if (
          this.selectedEventsDetails.maxAttendeece != null &&
          this.selectedEventsDetails.maxAttendeece !== undefined
        ) {
          this.availablePostions =
            this.selectedEventsDetails.maxAttendeece - this.countOfSignedUser;
        }
        this.availablePostions = this.availablePostions < 0 ? 0 : this.availablePostions;

      },
      (err) => {
        this.spinnerService.hide();
        if (err.value.statusText === ConstantValues.unknownError) {
          this.timeOutError = true;
        }
      }
    );
  }

  /** To add user for attendance
   * @class EventViewDetailsComponent
   * @method addEventAttendance
   */
  addEventAttendance(eventId, type, event) {
    this.timeOutError = false;
    this.userAttendance.workdayId = null;
    this.userAttendance.badgeId = null;
    if (type === "badge") {
      this.userAttendance.badgeId = event.target.value;
    }
    if (type === "workday") {
      this.userAttendance.workdayId = event.target.value;
    }

    if (event.target.value.trim().length === 6) {
      event.target.value = null;
      this.userAttendance.eventId = eventId;
      this.userAttendance.createdBy = this.loginData.userId;
      this.userAttendance.modifiedBy = this.loginData.userId;
      this.bpgEventsService.saveUserAttendance(this.userAttendance).subscribe(
        (data) => {
          if (data.message) {
            this.errorMsg = true;
            this.successMsg = false;
            this.alertSuccessAttended = false;
            setTimeout(() => {
              window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
            }, 500);
            this.userAttendanceMsg = data.message;
          } else {
            this.successMsg = true;
            this.errorMsg = false;
            this.alertSuccessAttended = false;
            setTimeout(() => {
              window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
            }, 500);
            this.userAttendanceMsg = "Attendance registered successfully!";
          }
          this.listAttendance();

        },
        (err) => {
          this.spinnerService.hide();
          if (err.value.statusText === ConstantValues.unknownError) {
            this.timeOutError = true;
          }
        }
      );
    }
  }

  /** For saving chapterId and eventId claim expense page
   * @class EventViewDetailsComponent
   * @method clearEditEventData
   */
  public saveExpenseClaimData() {
    const claimData = {
      chapterId: this.selectedEventsDetails.chapterId,
      eventId: this.selectedEventsDetails.eventId,
    };
    sessionStorage.setItem(
      "expenseNameAndChapterId",
      JSON.stringify(claimData)
    );
    sessionStorage.removeItem("editExpenseData");
  }

  /** For Navigate to Take Survey Page
   * @class EventViewDetailsComponent
   * @method gotoTakeSurvey
   */
  public gotoTakeSurvey() {
    this.eventId = this.selectedEventsDetails.eventId;
    this.router.navigate(["/take-survey", this.eventId]);
  }

  /** To select attendance load with confirmation
   * @class EventViewDetailsComponent
   * @method clickAttendanceLoad
   */
  clickAttendanceLoad() {
    this.errorMsg = false;
    this.successMsg = false;
    this.alertSuccessAttended = false;
    this.method = "changeEventStatus";
    this.param = "COMPLETED";
    this.msg1 =
      "This will complete the attendance load and you will not be able to add further attendee for the event";
  }

  /** To get group signup details
   * @class EventViewDetailsComponent
   * @method getGroupsignupList
   */
  getGroupsignupList() {
    this.userDeleted = false;
    this.userExists = false;
    this.screenView = "view";
    this.signUpSuccess = false;

   
    this.existingUsers = [];
    this.bpgEventsService
      .getGroupSignupDetails(this.eventId, this.loginData.userId)
      .subscribe((data) => {
        if (
          data.confirmedUserList != null &&
          data.confirmedUserList !== undefined
        ) {
          const allUserList = data;
          if (allUserList) {
            const confirmedList = allUserList.confirmedUserList;
            const notConfirmedUserList = allUserList.notConfirmedUserList;
            if (confirmedList.length > 0) {
              for (const confirm of confirmedList) {
                confirm.status = "Confirmed";
                this.existingUsers.push(confirm);
              }
            }
            if (notConfirmedUserList != null) {
              for (const notConfirmed of notConfirmedUserList) {
                notConfirmed.status = "On Waitlist";

                this.existingUsers.push(notConfirmed);
              }
            }
            if (confirmedList.length > 0) {
              this.numberOfElementsForExistingUsers = this.existingUsers.length;
            }
          }
        } else {
          this.screenView = "create";
        }
      });
  }
  /** To get survey details
   * @class EventViewDetailsComponent
   * @method getSurveyID
   */
  getSurveyID() {
    this.timeOutError = false;
    this.bpgEventsService.getSurveyId(this.surveyDetails).subscribe(
      (data) => {
        this.surveyIdDetails = data;
        this.surveyId = this.surveyIdDetails.surveyId;
        this.userId = this.loginData.userId;
        this.launchSurvey = true;
        this.takeSurvey = true;
        this.suveyTakenByUser(this.surveyId, this.userId);
      },
      (err) => {
        this.spinnerService.hide();
        if (err.value.statusText === ConstantValues.unknownError) {
          this.timeOutError = true;
        }
      }
    );
  }

  /** To get survey details
   * @class EventViewDetailsComponent
   * @method suveyTakenByUser
   */
  suveyTakenByUser(surveyId, userId) {
    this.timeOutError = false;
    this.SuveyTakenByUserDTO.surveyId = surveyId;
    this.SuveyTakenByUserDTO.userId = userId;
    this.bpgEventsService.suveyTakenByUser(this.SuveyTakenByUserDTO).subscribe(
      (data) => {
        this.suveyTakenByUserDetails = data;
        this.alreadyTakenSurvey =
          this.suveyTakenByUserDetails.userAlreadyTakenSurvey;
      },
      (err) => {
        this.spinnerService.hide();
        if (err.value.statusText === ConstantValues.unknownError) {
          this.timeOutError = true;
        }
      }
    );
  }

  /** To edit event
   * @class EventViewDetailsComponent
   * @method editEvent
   */
  editEvent() {
    this.selectedEventsDetails.edit = "single";
    sessionStorage.setItem(
      "editEventData",
      JSON.stringify(this.selectedEventsDetails)
    );
  }

  /** For filtering data by current page
   * @class SiteComponent
   * @method pageChanged
   * @params event
   */
  pageChanged(event) {
    this.landingDto.page = event - 1;
    this.currentPage = event;

    if (this.currentPage * this.limit < this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if (this.currentPage * this.limit > this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }
    this.listAttendance();
  }

  /** to list admins in table
   * @class AdminComponent
   * @method listAdmins
   */
  listAttendance() {
    this.timeOutError = false;
    this.bpgEventsService.listAttendance(this.landingDto).subscribe(
      (data) => {
        this.attendanceData = data.content;
        if (this.attendanceData.length === 0) {
          this.tableShow = false;
          this.noDataFound = true;
        } else {
          this.tableShow = true;
          this.noDataFound = false;
        }
        this.numberOfElements = data.totalElements;
      },
      (err) => {
        this.spinnerService.hide();
        if (err.value.statusText === ConstantValues.unknownError) {
          this.timeOutError = true;
        }
      }
    );
  }

  /** For searching the table through keywords
   * @class SiteComponent
   * @method searchMe
   */
  searchMe() {
    this.searchKey = this.searchKey ? this.searchKey : "";
    this.landingDto.page = 0;
    this.landingDto.searchTerm = this.searchKey;
    this.currentPage = 1;
    this.listAttendance();
  }

  /** For sorting the table through columns
   * @class SiteComponent
   * @method sortMe
   */

  public sortMe(sortingby) {
    if (this.landingDto.sortDirection === "ASC") {
      this.landingDto.sortDirection = "DESC";
      document.getElementById(sortingby + "1").classList.add("fading");
      document.getElementById(sortingby + "2").classList.remove("fading");
    } else {
      this.landingDto.sortDirection = "ASC";
      document.getElementById(sortingby + "2").classList.add("fading");
      document.getElementById(sortingby + "1").classList.remove("fading");
    }

    this.landingDto.sortProperty = sortingby;
    this.listAttendance();
  }

  enterPress(event) {
    if (event.target.value.trim().length < 6) {
      this.alertSuccessAttended = true;
      this.errorMsg = false;
      this.successMsg = false;
      setTimeout(() => {
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
      }, 500);
    }
  }

  formatTimeShow(time) {
    // Check correct time format and split into components
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value

      time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
      if (time[0] < 10) {
        time[0] = "0" + time[0];
      }
    }
    return time.join(""); // return adjusted time or original string
  }

  convertTimeTo24Hours(time) {
    let hours = Number(time.match(/^(\d+)/)[1]);
    const minutes = Number(time.match(/:(\d+)/)[1]);
    const AMPM = time.match(/\s([^\s]*)$/)[1];
    if (AMPM === "PM" && hours < 12){ hours = hours + 12;}
    if (AMPM === "AM" && hours === 12){ hours = hours - 12;}
    let sHours = hours.toString();
    let sMinutes = minutes.toString();
    if (hours < 10){ sHours = "0" + sHours;}
    if (minutes < 10) {sMinutes = "0" + sMinutes;}
    return `${sHours}:${sMinutes}`;
  }

  public sendEmailNotification() {
    this.sendNotification = true;
    this.spinnerService.show();

    this.userAndRoleIdDTO = {
      userId: this.loginDetails["userId"],
      roleId: localStorage.getItem("adminId"),
      siteId: null,
    };
    this.bpgEventsService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(
      (data) => {
        this.chapterList = data;
        this.chapterList.map((i) => {
          i.siteName = `${i.siteName}-${i.bpgName}`;
          return i;
        });
        if (this.chapterList.length > 1) {
          this.chapterList.unshift({
            chapterId: 0,
            siteName: this.selectAllConstant,
            bpgName: "",
          });
        }
        for (let i = 0; i < this.chapterList.length; i++) {
          if (i === 0) {
            this.chapterIds = this.chapterList[i].chapterId;
          } else {
            this.chapterIds =
              `${this.chapterIds},${this.chapterList[i].chapterId}`;
          }
        }

        this.siteData = {
          filter: {
            chapterId: this.chapterIds,
          },
          moduleId: 0,
          page: 0,
          presentRole: "",
          searchTerm: "",
          size: 0,
          sortDirection: "ASC",
          sortProperty: "",
          uid: "",
        };
        this.bpgCommonService.getSiteList(this.siteData).subscribe((data) => {
          this.siteList = data;
          //filter default site from sitelist
          this.siteList = this.siteList.filter(
            (site) => site.locationCode !== "DFLT"
          );
          this.siteList.unshift({
            siteId: 0,
            siteName: this.selectAllConstant,
            bpgName: "",
          });
          for (let i = 0; i < this.siteList.length; i++) {
            if (i === 0) {
              this.allSiteIds = this.siteList[i].siteId;
            } else {
              this.allSiteIds = `${this.allSiteIds}${this.siteList[i].siteId},`;
            }
          }

          if (this.adminId === "1" || this.adminId === "4" || this.isNaacAdmin){
            this.siteChange(0);
          }
        });

        this.selectedBpgsData = {
          filter: {
            siteId: this.siteId,
            userId: this.userAndRoleIdDTO.userId,
            adminId: this.userAndRoleIdDTO.roleId,
          },
          moduleId: 0,
          page: 0,
          presentRole: "string",
          searchTerm: "string",
          size: 0,
          sortDirection: "ASC",
          sortProperty: "string",
          uid: "string",
        };
        this.bpgCommonService
          .getMyBPGsList(this.selectedBpgsData)
          .subscribe((data) => {
            this.bpgList = data;
            this.bpgList.unshift({ bpgId: 0, bpgName: this.selectAllConstant });
            for (let i = 0; i < this.bpgList.length; i++) {
              if (i === 0) {
                this.allBpgIds = this.bpgList[i].bpgId;
              } else {
                this.allBpgIds = `${this.allBpgIds}${this.bpgList[i].bpgId},`;
              }
            }
          });

        this.spinnerService.hide();
      },
      (err) => {
        this.spinnerService.hide();
        if (err.value.statusText === ConstantValues.unknownError) {
          this.timeOutError = true;
        }
      }
    );
  }

  /** For site change from site list
   * @class EventsApprovalComponent
   * @method siteChange
   * @returns Promise
   */
  public siteChange(event) {
    this.bpgList = [];
    this.chapterList = [];
    this.selectedBpgId = null;
    this.bpgValue = null;

    if (event !== undefined) {
      this.selectedSiteId = event.siteId;
    } else {
      this.selectedSiteId = 0;
      this.selectedSiteId = null;
    }

    if (this.siteId === 0) {
      this.siteId = null;
    }
    this.chapterLandingDto = {
      siteIdList: this.siteId,
      userId: this.userAndRoleIdDTO.userId,
      roleId: this.userAndRoleIdDTO.roleId,
    };
    this.bpgEventsService.getChapterDropDown(this.chapterLandingDto).subscribe(
      (data) => {
        this.chapterList = data;
        this.chapterList.map((i) => {
          i.siteName = `${i.siteName}-${i.bpgName}`;
          return i;
        });
      },
      (err) => {
        this.spinnerService.hide();
        if (err.value.statusText === ConstantValues.unknownError) {
          this.timeOutError = true;
        }
      }
    );
  }

  /** For bpg change from bpg list
   * @class EventsApprovalComponent
   * @method bpgChange
   * @returns Promise
   */

  bpgChange(event) {
    if (event !== undefined) {
      this.selectedBpgId = event.bpgId;
    } else {
      this.selectedBpgId = null;
    }
  }
}
